import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

import { getMessage } from 'util/locale';

const baseString = 'vra-history-multi-season-header';
const classString = classNames({
  [`${baseString}`]: true
});

const HistoryHeader = ({
  displayHarvestDate=false
}) => (
  <tr className={classString}>
    <th className={`${baseString}--include`}>{ getMessage('label-text__include') }</th>
    <th className={`${baseString}--data-type`}>{ getMessage('label-text__data-type') }</th>
    <th className={`${baseString}--crop-harvested`}>{ getMessage('label-text__crop-harvested') }</th>
    {displayHarvestDate && (<th className={`${baseString}--date-harvested`}>
      { getMessage('label-text__crop-date') }
    </th>)}
  </tr>
);

HistoryHeader.propTypes = {
  displayHarvestDate: propTypes.bool
};

export default HistoryHeader;
